import { Router } from '../router/Router';
import { Component } from './Component';
import { Header } from './Header';
import { ApiService } from '../services/ApiService';

/**
 * Component Polling result.
 * Base class for confirmation, exists and timeout stages.
 */
export class PollingResult extends Component {
  /**
   * String of the dom element of the submit button.
   *
   * @type {string}
   */
  static btnSubmitDOMSelector = '#btnSubmit';

  /**
   * Render template.
   *
   * @param {object} opts - The object to set in the controller.
   */
  render(opts) {
    if (opts.stage === 'confirmation') {
      Component.updateTracking({ type_page: 'confirmation' });
    }

    super.render(opts);

    if (opts.stage === 'confirmation') {
      const confirmationTitle = document.querySelector('#confirmation-title');

      if (confirmationTitle !== null) {
        confirmationTitle.focus();
      }
    } else if (opts.stage === 'exists') {
      const existsTitle = document.querySelector('#exists-title');

      if (existsTitle !== null) {
        existsTitle.focus();
      }
    }

    this.id = opts && opts.id;

    if (opts && opts.keepBackButton !== true) {
      Header.deleteBackButton();
    }

    this.attachSubmitEvent();
  }

  /**
   * Attach submit event.
   */
  attachSubmitEvent() {
    const btnSubmit = document.querySelector(PollingResult.btnSubmitDOMSelector);

    if (btnSubmit) {
      btnSubmit.addEventListener('click', () => this.submit());
    }
  }

  /**
   * Submit action.
   * Close the application.
   */
  submit() {
    const token = ApiService.invitationId;

    if (Eui.allowToken && token !== undefined) {
      Router.closeApp({
        id: this.id,
        redirectUrl: decodeURIComponent(Eui.returnUrl).replace(/%s/g, token),
      });
    } else if (Eui.allowToken && !token) {
      Router.closeApp({
        id: this.id,
        redirectUrl: Eui.returnUrlError,
      });
    } else {
      Router.closeApp({
        id: this.id,
      });
    }
  }
}
